import React, { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '../../lib/utils';

// Carrier logo with a graceful fallback. The placeholder icon renders INSTEAD
// of the image, never behind it — logos with transparency would otherwise let
// the icon show through them.
const CarrierLogo = ({ src, name, className }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <span className={cn('flex items-center', className)}>
        <Package className="h-5 w-5 text-slate-300" aria-hidden="true" />
      </span>
    );
  }

  return (
    <img
      src={src}
      alt={name ? `${name} logo` : ''}
      onError={() => setFailed(true)}
      className={cn('object-contain object-left', className)}
    />
  );
};

export { CarrierLogo };
